import { useCobrandStore } from '~/store/cobrand'

export default defineNuxtRouteMiddleware(async (to) => {
  try {
    await useCobrandStore().load(to)
  } catch (err) {
    if (err.response && err.response.status >= 500) {
      log.error('Error Loading Cobrand', err)
    } else if (!err.response) {
      log.error('Error Loading Cobrand', err)
    }
  }
})
